import { CSSProperties } from 'react'

import styled from '@emotion/styled'

type PositionProps = {
  position: CSSProperties['position']
  top?: CSSProperties['top']
  right?: CSSProperties['right']
  bottom?: CSSProperties['bottom']
  left?: CSSProperties['left']
  inset?: CSSProperties['inset']
}
export const Position = styled.div<PositionProps>`
  position: ${({ position }) => position};
  ${({ top }) => top && `top: ${top};`}
  ${({ right }) => right && `right: ${right};`}
  ${({ bottom }) => bottom && `bottom: ${bottom};`}
  ${({ left }) => left && `left: ${left};`}
  ${({ inset }) => inset && `inset: ${inset};`}
`
